import { PatientKind } from "common/types";

import { SelectedProductFilters, ProductSearchFilters } from "../types";
import SearchFilterTags from "./SearchFilterTags";

type ProductSearchFilterTagsProps = {
  options: ProductSearchFilters;
  value: SelectedProductFilters;
  onChange: (search: Partial<SelectedProductFilters>) => void;
};

const ProductSearchFilterTags = ({ options, value, onChange }: ProductSearchFilterTagsProps) => {
  return (
    <>
      <SearchFilterTags<PatientKind>
        options={options.species}
        value={value.species}
        onChange={(species) => onChange({ species })}
      />
      <SearchFilterTags
        options={options.categories}
        value={value.category_ids}
        onChange={(category_ids) => onChange({ category_ids })}
      />
      <SearchFilterTags
        options={options.manufacturers}
        value={value.manufacturer_ids}
        onChange={(manufacturer_ids) => onChange({ manufacturer_ids })}
      />
      <SearchFilterTags<boolean>
        options={options.prescription_required}
        value={value.prescription_required}
        onChange={(prescription_required) => onChange({ prescription_required })}
      />
    </>
  );
};

export default ProductSearchFilterTags;
